import { render, staticRenderFns } from "./PastEvents.vue?vue&type=template&id=1b943dbe&"
import script from "./PastEvents.vue?vue&type=script&lang=ts&"
export * from "./PastEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PastEvents.vue"
export default component.exports